import React, { Component } from 'react';
import PropTypes from 'prop-types';
import '../../../styles/main.scss';

class TextField extends Component {
  constructor(props) {
    super(props);
    this.inputRef = React.createRef();
    this.state = {
      focused: false,
      touched: false,
      internalError: ''
    };
    this.onFocus = this.onFocus.bind(this);
    this.onBlur = this.onBlur.bind(this);
    this.handleOnChange = this.handleOnChange.bind(this);
  }

  render() {
    const { error, errorMessage, required, label, value } = this.props;
    const { internalError, touched } = this.state;

    const isEmpty = !value || value.toString().trim() === '';
    const shouldShowEmptyError = required && isEmpty && touched;

    const finalError =
      error || errorMessage || (shouldShowEmptyError ? internalError : '');
    const hasError = !!finalError;

    return (
      <div className={`new-dev-input-design`}>
        <label
          htmlFor={this.props.id}
          className={`new-label-design`}
        >
          {label}{' '}
          {required && <b style={{ color: 'rgba(209, 45, 48, 1)' }}>*</b>}
        </label>
        <input
          type={this.props.type}
          ref={this.inputRef}
          id={this.props.id}
          className={`new-input-design ${hasError ? 'input-error' : ''}`}
          disabled={this.props.disabled}
          autoComplete={this.props.autoComplete}
          min={this.props.min}
          minLength={this.props.minLength}
          value={this.props.value}
          onFocus={this.onFocus}
          onBlur={this.onBlur}
          onChange={this.handleOnChange}
          onKeyPress={this.props.onKeyPress}
          onKeyDown={this.props.onKeyDown}
          placeholder={label}
          noValidate
        />
        <div
          className={`mdc-line-ripple ${
            this.state.focused ? 'mdc-line-ripple--active' : ''
          } ${this.props.lineRippleClass}`}
        ></div>

        {hasError && (
          <div className="field-error-message">
            <span style={{ color: '#d32f2f', fontSize: '12px' }}>
              {finalError}
            </span>
          </div>
        )}
      </div>
    );
  }

  componentDidMount() {
    if (this.props.focused) {
      this.inputRef.current.focus();
      this.inputRef.current.selectionStart =
        this.inputRef.current.selectionEnd = this.inputRef.current.value.length;
    }
  }

  validate() {
    if (this.props.required) {
      const isEmpty =
        !this.props.value || this.props.value.toString().trim() === '';
      if (isEmpty) {
        const errorMsg =
          this.props.emptyErrorMessage || 'Este campo es obligatorio';
        this.setState({
          internalError: errorMsg,
          touched: true
        });
        return false;
      }
    }
    this.setState({ internalError: '' });
    return true;
  }

  onFocus() {
    if (!this.state.focused) {
      this.setState({ focused: true });
    }
    if (this.state.internalError) {
      this.setState({ internalError: '' });
    }
  }

  onBlur() {
    if (this.state.focused) {
      this.setState({ focused: false, touched: true });
    }
    if (this.props.required) {
      const isEmpty =
        !this.props.value || this.props.value.toString().trim() === '';
      if (isEmpty) {
        const errorMsg =
          this.props.emptyErrorMessage || `Este campo es obligatorio`;
        this.setState({
          internalError: errorMsg,
          touched: true
        });
      }
    }
  }

  handleOnChange(event) {
    if (this.state.internalError && event.target.value.trim() !== '') {
      this.setState({ internalError: '' });
    }

    if (this.props.onChange) {
      this.props.onChange(event);
    }
  }
}

TextField.propTypes = {
  id: PropTypes.string.isRequired,
  focused: PropTypes.bool,
  fieldClass: PropTypes.string,
  inputClass: PropTypes.string,
  labelClass: PropTypes.string,
  lineRippleClass: PropTypes.string,
  disabled: PropTypes.bool,
  required: PropTypes.bool,
  autoComplete: PropTypes.string,
  label: PropTypes.string,
  onChange: PropTypes.func,
  onKeyPress: PropTypes.func,
  onKeyDown: PropTypes.func,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  type: PropTypes.string,
  min: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  minLength: PropTypes.number,
  error: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  errorMessage: PropTypes.string,
  emptyErrorMessage: PropTypes.string
};

TextField.defaultProps = {
  focused: false,
  fieldClass: '',
  inputClass: '',
  labelClass: '',
  lineRippleClass: '',
  disabled: false,
  required: false,
  autoComplete: 'off',
  type: 'text',
  min: '',
  minLength: null,
  onKeyPress: null,
  onKeyDown: null,
  error: false,
  errorMessage: '',
  emptyErrorMessage: ''
};

export default TextField;
